import {Component, ContentChild, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef} from '@angular/core';
import {reorder} from '../../_utils/sortable-utils';

@Component({
    selector: 'bb-multi-select-filter',
    templateUrl: './multi-select-filter.component.html',
    styleUrls: ['./multi-select-filter.component.scss'],
})
export class MultiSelectFilterComponent implements OnInit, OnChanges {
    @Input() title = 'Select';
    @Input() items: any[];
    @Input() selectionParam = 'selected';
    @Input() disabledParam = 'disabled';
    @Input() selectedItems: any[];
    @Input() sortable = false;
    @Input() includeAdd = false;
    @Input() includeAlphabeticalSort = false;

    @Input() filterItems: (items: any[], filter: string) => any[];
    @Input() markSelected: (items: any[], selectedItems: any[], selectionParam: string, disabledParam: string) => void;

    @Output() selectedItemsChange: EventEmitter<any[]> = new EventEmitter<any[]>();
    @Output() removeItem: EventEmitter<any> = new EventEmitter<any>();
    @Output() addItem: EventEmitter<any> = new EventEmitter<any>();
    @Output() sortAlphabetical: EventEmitter<any> = new EventEmitter<any>();

    @ContentChild('displayTemplate') displayTemplate: TemplateRef<any>;
    @ContentChild('selectTemplate') selectTemplate: TemplateRef<any>;

    internalSelectedItems = [];
    active = false;
    filteredItems = [];

    filter = '';

    ngOnInit(): void {
        this.callFilter();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes.items) {
            this.callFilter();
            if (!!this.markSelected) {
                this.markSelected(this.items, this.selectedItems, this.selectionParam, this.disabledParam);
            }
        }

        if (!!changes.selectedItems && !!this.markSelected) {
            this.internalSelectedItems = this.selectedItems;
            this.markSelected(this.items, this.selectedItems, this.selectionParam, this.disabledParam);
        } else {
            this.updateInternal();
        }
    }

    toggleItems() {
        const items = [...this.filteredItems];
        if (!this.allSelected()) {
            items.forEach(i => i[this.selectionParam] = true);
        } else {
            items.forEach(i => i[this.selectionParam] = false);
        }
        this.updateInternal();
    }

    updateInternal() {
        if (!this.selectedItems) {
            this.internalSelectedItems = this.items.filter(i => i[this.selectionParam]);
        } else {
            this.selectedItemsChange.emit(this.items.filter(i => i[this.selectionParam]));
        }
    }

    partialSelected() {
        return !!this.filteredItems && this.filteredItems.some(i => i[this.selectionParam])
            && this.filteredItems.some(i => !i[this.selectionParam]);
    }

    allSelected() {
        return !!this.filteredItems && !this.filteredItems.some(i => !i[this.selectionParam]);
    }

    callFilter() {
        this.filteredItems = this.filterItems(this.items, this.filter);
    }

    removeSingle(event: any, item: any) {
        if (!!event) {
            event.stopPropagation();
        }
        item[this.selectionParam] = false;
        this.updateInternal();
        if (!this.selectedItems) {
            this.updateInternal();
        } else {
            this.removeItem.emit(item);
        }
    }

    addItemClicked(event) {
        if (!!event) {
            event.stopPropagation();
        }
        this.addItem.emit();
    }

    reorder(event) {
        reorder(this.internalSelectedItems, event);
    }
}
